import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initSentry } from '@/libs/sentry'
import { initTooltip } from '@/libs/tooltip'
import { initFilters } from '@/filters'
import logWelcomeMessage from '@/utils/consoleWelcome'
import { clickOutside } from '@/directives/clickOutside'
import { overflowTooltip } from '@/directives/overflowTooltip'

import FieldResolver from '@/components/fields/FieldResolver.vue'
import ListComponent from '@/components/listings/ListComponent.vue'
import Loader from '@/components/Loader.vue'

const app = createApp(App)

// Suppress expected warnings from third-party libraries
app.config.warnHandler = (msg, vm, trace) => {
  // Ignore FilePond labelFileProcessingError prop type warning
  if (msg.includes('labelFileProcessingError')) {
    return
  }
  // Log all other warnings normally
  console.warn(`[Vue warn]: ${msg}${trace}`)
}

// Plugins
app.use(store)
app.use(router)
initSentry(app)
initTooltip(app)
initFilters(app)

// Global directives
app.directive('click-outside', clickOutside)
app.directive('overflow-tooltip', overflowTooltip)

// Global components
app.component('FieldComponent', FieldResolver)
app.component('ListComponent', ListComponent)
app.component('Loader', Loader)

// Auto-register all UI components from src/components/ui/
const uiComponents = import.meta.glob('@/components/ui/*.vue', { eager: true })
for (const path in uiComponents) {
  const name = path.split('/').pop().replace('.vue', '')
  app.component(name, uiComponents[path].default)
}

app.mount('#app')

// Display welcome message in console
logWelcomeMessage()
